import { Component, OnInit, ViewChild } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import serverConfigInfo from "../../../../../Server/config.json";

@Component({
  selector: "app-order-booking",
  templateUrl: "./order-booking.component.html",
  styleUrls: ["./order-booking.component.css"],
  providers: [DatePipe]
})
export class OrderBookingComponent implements OnInit {
  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;
  @ViewChild("input9", { read: MatInput }) input9: MatInput;

  screentitle: string = "Manage Booking";
  headerDivName : string = "errMsgDiv";
  orderBooking_aff_partner:any = [];
  TBO_button: boolean;
  invaliddate = false;
  showsingle1 = true;
  showMultiple1 = true;
  isUniqueFilter: boolean = false;
  final;
  demoButton: any;
  buttonFlag: boolean;
  TBO_sms = false;
  downd = true;
  change: any;
  inputPlaceholder = {
    intermilesNumber : "Enter INTERMILES Number",
    airlinePnr : "Enter Airline PNR",
    bookingReferenceNumber : "Enter Booking Reference No",
    ticketNumber : "Enter Ticket No",
    firstName : "Enter First Name",
    lastName : "Enter Last Name",
    bookingDateFrom : "From Booking Date",
    bookingDateTo : "To Booking Date",
    departureFrom : "Departure From",
    departureTo : "Departure To"
  }
  // switchType : string ;
  searchlist: boolean = true;
  mydate = new Date();
  journeydate = false;
  search_details;
  isFname = false;
  isLname = false;
  tomorrow1;
  isOrd = false;
  isPnr = false;
  IsSpace = false;
  disablebtn = true;
  bookingdate = false;
  tomorrow;
  //TBO_first_name= "";
  //TBO_last_name = "";
  //TBO_no ="";
  booking_ref: any = "asdasd";
  p: number = 1;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbookingOB: boolean = true;
  bookinglist: boolean = false;
  booking_details: any = "";
  booking_details_info: any = [];
  // segment_details: any = "";
  pax_detail: any = "";

  segment_details1: any = [];
  segment_details2: any = [];
  selectedOutboundPaxArray = [];
  selectedInboundPaxArray = [];
  loader: any = false;
  isloader: any = false;
  isAccrual: boolean = false;
  uid;
  cancelbtn;
  BOOKING_STATUS;
  cancelHistory: any = [];
  isCancelOpen: boolean = false;
  isJpNumber: boolean = false;
  noresult: any = "";
  booking_status: any = [
    { key: 2, value: "Booked" },
    { key: 4, value: "Failed" },
    { key: 1, value: "Pending" },
    { key: 7, value: "Canceled" },
    { key: 12, value: "Rescheduled" }
  ];
  TransactionscreenId: any = "";
  ErrmessageOB: any = "";
  MilesYouHave: any = "";
  totalMiles: any = "";
  Rpm: any = 0.3;
  MilesRefunded: any = 0;
  CancellationMiles: any = 0;
  CancellationMilesInbound: any = 0;
  cancelResponse: any = {};
  newDate: any = new Date();
  myDate: any = new Date();
  totalItems: number = 1;
  typeOfRedemption: any = "A";
  typeOfRedem: any = "A";
  ancillary_bkg_status_map = [
    // {"key":"undefined", "value": "Not Opted"},
    { "key": 1, "value": "Not Opted" },
    { "key": 0, "value": "Pending" },
    { "key": 2, "value": "Confirmed" },
    { "key": 4, "value": "Failed" },
    { "key": 5, "value": "Cancelled" },
    { "key": 6, "value": "Reversed" }
  ]
  ancillary_type_map = [
    { "key": 1, "value": "Meal" },
    { "key": 2, "value": "Baggage" },
    { "key": 3, "value": "Seat" },
    { "key": 4, "value": "Lounge" },
    { "key": 0, "value": "Travel Insurance" }
  ]
  ancillary_type_map_req = {
    "1": "Meal",
    "2": "Baggage",
    "3": "Seat",
    "0": "Travel Insurance",
    "4": "Lounge"
  }
  ancillary_bkg_status_map_req = {
    // {"key":"undefined", "value": "Not Opted"},
    "1": "Not Opted",
    "0": "Pending",
    "2": "Confirmed",
    "4": "Failed",
    "5": "Cancelled",
    "6": "Reversed"
  }
  TBO_orederID: any;
  TBO_ref_no: any;
  SMS: string;
  is_tbo_on: any = false;
  IsErr: boolean = false;
  initialPageCount: number = 1;

  constructor(
    private vernostService: VernostServiceService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {

    // this.myDate.setDate(this.myDate.getDate() - 1)
    //this.TBO_button = false
    for(let item of serverConfigInfo.affliatepartner.partners){
      this.orderBooking_aff_partner.push({key: item, value: item});
    }
    this.isJpNumber = false;
    this.cancelbtn = true;
    //this.TBO_button = false;
    this.isCancelOpen = false;
    this.uid = localStorage.getItem("uid");
    this.is_tbo_on = localStorage.getItem("is_tbo_on");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.search_details = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "E",
      aff_partner: "E",
      isMailSent: "",
      tripdate_From: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: "",
      ancillary_status: "",
      ancillary_type: "",
      emt: "",
      supplier_id: ""
    };
  }
  ngAfterContentInit() {
    this.search_details.bookingdate_to = new Date();
    this.search_details.bookingdate_from = new Date();
    this.final = this.search_details.bookingdate_to.setDate(this.search_details.bookingdate_to.getDate());
    this.final = new Date(this.final);

    this.IsEmptyVal = true;
    //this.searchData();
  }
  TBOmethod() {

    let TBO_first_name = this.search_details.first_name
    let TBO_last_name = this.search_details.last_name
    let TBO_no = this.search_details.jp_number

    let TBO_data = {
      "jpNumber": TBO_no,
      "firstName": TBO_first_name,
      "lastName": TBO_last_name

    }

    if (TBO_first_name == undefined || TBO_first_name == "") {
      document.getElementById("fnErr").innerHTML = "please enter first name "
    }
    if (TBO_last_name == undefined || TBO_last_name == "") {
      document.getElementById("lnErr").innerHTML = "please enter Last name "
    }
    if (TBO_no == undefined || TBO_no == "") {
      document.getElementById("JpErr").innerHTML = "please enter INTERMILES NO"
    }
    if ((TBO_first_name != undefined && TBO_first_name != "") &&
      (TBO_last_name != undefined && TBO_last_name != "") &&
      (TBO_no != undefined && TBO_no != "")) {
      this.vernostService.CreateTBOOrder(TBO_data).subscribe((res) => {

        if (res['Status'] == true) {
          this.TBO_orederID = res['CreatedOrder'];
          this.TBO_sms = true;
          this.TBO_ref_no = (this.TBO_orederID.toString().length < 12 ? "JPUB" + this.TBO_orederID : this.TBO_orederID);
          this.search_details.order_id = this.TBO_ref_no;
          //console.log("this.TBO_ref_no=====",this.TBO_ref_no);
          this.SMS = this.TBO_ref_no + " successfully created";

          this.search_details.first_name = "";
          this.search_details.last_name = "";
          this.search_details.jp_number = "";
          this.search_details.bookingdate_from = "";
          this.search_details.bookingdate_to = "";
        }
        else {
          this.TBO_sms = true;
          this.SMS = "Incorrect INTERMILES Number";
        }
      });
    }


  }
  searchForm() {
    this.segment_details1 = [];
    this.segment_details2 = [];
    this.selectedOutboundPaxArray = [];
    this.selectedInboundPaxArray = [];
    this.existingbookingOB = true;
    this.bookinglist = false;
    this.searchData();
    this.ErrmessageOB = "";
    this.CancellationMilesInbound = 0;
    this.CancellationMiles = 0;
  }
  searchData() {
    this.noresult = "";
    this.loader = true;
    this.searchlist = false;
    this.cancelbtn = true;
    this.search_result_list = [];
    this.order_Id_list = [];
    this.search_detail_list = [];

    var Todate = this.search_details.bookingdate_to
    if (Todate != "") {
      Todate.setDate(Todate.getDate());
    }
    this.search_details.bookingdate_from = this.datePipe.transform(
      this.search_details.bookingdate_from,
      "yyyy-MM-dd"
    );
    this.search_details.tripdate_From = this.datePipe.transform(
      this.search_details.tripdate_From,
      "yyyy-MM-dd"
    );
    this.search_details.tripdate_to = this.datePipe.transform(
      this.search_details.tripdate_to,
      "yyyy-MM-dd"
    );
    Todate = this.datePipe.transform(
      Todate,
      "yyyy-MM-dd"
    );
    var boofrom = this.search_details.bookingdate_from;
    var bookto = Todate;
    var AirLine_Pnr = this.search_details.airlinepnr;
    var jp_number = "";
    if (this.typeOfRedemption == 'A') {
      jp_number = this.search_details.jp_number;
    }
    if (this.typeOfRedemption == 'R') {
      jp_number = "00" + this.search_details.jp_number
    }
    if ((this.search_details.tripdate_to == null || this.search_details.tripdate_to == '') && (this.search_details.tripdate_From != '' || this.search_details.tripdate_From != null)) {
      this.search_details.tripdate_to = this.search_details.tripdate_From
    }

    if ((this.search_details.tripdate_From == null || this.search_details.tripdate_From == '') && (this.search_details.tripdate_to != '' || this.search_details.tripdate_to != null)) {
      this.search_details.tripdate_From = this.search_details.tripdate_to;
    }
    this.search_details.order_id = this.search_details.order_id.trim();
    var BOOKING_REF_NO = (this.search_details.order_id.toString().length <= 15 ? this.search_details.order_id.slice(4, this.search_details.order_id.length) : this.search_details.order_id);
    // BOOKING_REF_NO = BOOKING_REF_NO.trim()
    var data = {
      jp_number: jp_number,
      order_id: BOOKING_REF_NO,
      first_name: this.search_details.first_name,
      last_name: this.search_details.last_name,
      airlinepnr: AirLine_Pnr.toUpperCase(),
      fromdate: this.search_details.tripdate_from,
      status: this.search_details.status,
      todate: this.search_details.tripdate_to,
      booking_fromdate: boofrom,
      booking_todate: bookto,
      Ticket_No: this.search_details.Ticket_No,
      pagination: this.p,
      isMailSent: this.search_details.isMailSent,
      typeOfRedemption: this.typeOfRedemption,
      ancillary_status: (this.search_details.ancillary_status == "") ?
        "" : this.ancillary_bkg_status_map_req[this.search_details.ancillary_status],
      ancillary_type: (this.search_details.ancillary_type == "") ?
        "" : this.ancillary_type_map_req[this.search_details.ancillary_type],
      from_departure_date: this.search_details.tripdate_From,
      to_departure_date: this.search_details.tripdate_to,
      emtId: this.search_details.emt,
      supplierId: this.search_details.supplier_id,
      affiliate_partner: this.search_details.aff_partner,
      isUniqueFilter: this.isUniqueFilter,
      initialPageCount: this.initialPageCount
    };
    //  console.log("Data::::",data);
    this.vernostService.getExistingBooking(data).subscribe(async response => {
      console.log("search_detail_list========", JSON.stringify(response));
      this.typeOfRedem = this.typeOfRedemption;
      var Data = response
      var count = Data[0].count;
      this.initialPageCount = Data[0].count
      this.totalItems = count;
      this.search_result_list = Data[0].result;
      var SegmentList = [];
      for (var i = 0; i < this.search_result_list.length; i++) {

        if ((this.order_Id_list.indexOf(this.search_result_list[i].Booking_Ref) == -1 && this.search_result_list[i].PASSENGER_NO == 1)
        || (this.order_Id_list.indexOf(this.search_result_list[i].Booking_Ref) == -1)) {
          this.order_Id_list.push(this.search_result_list[i].Booking_Ref);
          this.search_detail_list.push(this.search_result_list[i]);
        }      
      }

      if (
        this.search_detail_list.length == 0 ||
        this.search_detail_list == undefined ||
        this.search_detail_list == ""
      ) {
        // alert("here");
        this.noresult = "Result Not Found";
        this.loader = false;
        //document.getElementById("noresulrErr").innerHTML = "Result Not Found";
      } else {
        this.loader = false;
      }
    });
  }


  IsEmptyVal: boolean = false;
  isEmpty() {

    if(this.search_details.airlinepnr !== "" || this.search_details.order_id !== "" || this.search_details.Ticket_No !== "") {
      this.isUniqueFilter = true;
      this.search_details.ancillary_type = "";
      this.search_details.status = "E";
      this.search_details.ancillary_status = "";
    } else {
      this.isUniqueFilter = false;
    }

    this.p = 1
    if (this.typeOfRedemption == 'A' && this.is_tbo_on == "true") {
      if ((this.search_details.jp_number != "" && this.search_details.jp_number != undefined) &&
        (this.search_details.first_name != "" && this.search_details.first_name != undefined) &&
        (this.search_details.last_name != "" && this.search_details.last_name != undefined)) {
        // console.log("1");

        this.buttonFlag = true;
      }
      else {
        //console.log("2");

        this.buttonFlag = false;
      }

    }
    if (this.typeOfRedemption == 'R') {
      //console.log("3");

      this.buttonFlag = false;

    }

    if (this.search_details.jp_number == '' && this.search_details.airlinepnr == '' &&
      this.search_details.order_id == '' && this.search_details.Ticket_No == '' &&
      this.search_details.first_name == '' && this.search_details.last_name == ''
      && this.search_details.status == "E"
      && this.search_details.emt == '' && this.search_details.supplier_id == ''
      && ((this.search_details.bookingdate_from == "" || this.search_details.bookingdate_from == null)
        || (this.search_details.bookingdate_to == "" || this.search_details.bookingdate_to == null)) && ((this.search_details.tripdate_From == "" || this.search_details.tripdate_From == null) || (this.search_details.tripdate_to == "" || this.search_details.tripdate_to == null))) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;

    }
    if (((this.search_details.bookingdate_from == "" || this.search_details.bookingdate_from == null) && (this.search_details.bookingdate_to != "" && this.search_details.bookingdate_to != null)) || ((this.search_details.bookingdate_from != "" && this.search_details.bookingdate_from != null) && (this.search_details.bookingdate_to == "" || this.search_details.bookingdate_to == null))) {
      this.IsEmptyVal = false;
    }
    if (((this.search_details.tripdate_From == "" || this.search_details.tripdate_From == null) && (this.search_details.tripdate_to != "" && this.search_details.tripdate_to != null)) || ((this.search_details.tripdate_From != "" && this.search_details.tripdate_From != null) && (this.search_details.tripdate_to == "" || this.search_details.tripdate_to == null))) {
      this.IsEmptyVal = false;
    }

  }

  selectTypeOfRedemption(type) {

    this.typeOfRedemption = type;
    //console.log(type);

    if (type == 'A') {
      this.isEmpty();
      this.isAccrual = true;
    } else {
      this.search_details.aff_partner = 'E';
      this.isAccrual = false;
    }

  }

  pageCount(count) {
    this.p = count;
    this.searchData()
    console.log("P:::", this.p);
  }
  book_details(param) {

    // this.router.navigate(['/navigation/ordermanage']);
    var req = { booking_ref: param };
    console.log("booking_ref: param=========", req);

    this.router.navigate(["/navigation/ordermanage"], { queryParams: req });
  }
  orderValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.order_id;
    if (JPNo.length > 0) {
      if (JPNo.length < 14) {
        document.getElementById("orErr").innerHTML =
          "Please enter 18 digit Booking Reference No ";
        document.getElementById("orErr").style.color = "red";
        this.isOrd = true;
        this.IsErr = true;
      } else {
        document.getElementById("orErr").innerHTML = "";
        this.isOrd = false;
        this.IsErr = false;
      }
    }
  }
  jpNumberValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.jp_number;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("JpErr").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("JpErr").style.color = "red";
      this.isJpNumber = true;
      this.IsErr = true;
    } else {
      document.getElementById("JpErr").innerHTML = "";
      this.isJpNumber = false;
      this.IsErr = false;
    }
  }

  fnameValidation() {

    this.disablebtn = false;
    var regex = /^[A-Za-z]+$/;

    var JPNo = this.search_details.first_name;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("fnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("fnErr").style.color = "red";
      this.isFname = true;
      this.IsSpace = true;
      this.IsErr = true;
    } else {
      document.getElementById("fnErr").innerHTML = "";
      this.isFname = false;
      this.IsSpace = false;
      this.IsErr = false;
    }
  }
  lnameValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z]+$/;

    var JPNo = this.search_details.last_name;

    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("lnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("lnErr").style.color = "red";
      this.isLname = true;
      this.IsSpace = true;
      this.IsErr = true;
    } else {
      document.getElementById("lnErr").innerHTML = "";
      this.isLname = false;
      this.IsSpace = false;
      this.IsErr = false;
    }
  }
  orderValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.order_id;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("orErr").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("orErr").style.color = "red";
      this.isOrd = true;
      this.IsErr = true;
    } else {
      document.getElementById("orErr").innerHTML = "";
      this.isOrd = false;
      this.IsErr = false;
    }
  }

  pnrValidation() {
    this.disablebtn = false;

    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.airlinepnr;

    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("pnrNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("pnrNO").style.color = "red";
      this.isPnr = true;
      this.IsErr = true;

    } else {
      document.getElementById("pnrNO").innerHTML = "";
      this.isPnr = false;
      this.IsErr = false;
    }
  }
  EMTidValidation() {
    // this.disablebtn = false;

    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details.emt = this.search_details.emt.toUpperCase();
    var EmtId = this.search_details.emt;

    if (EmtId != "" && regex.test(EmtId) == false) {
      document.getElementById("EMT_id_err").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("EMT_id_err").style.color = "red";
      this.IsErr = true;
    } else {
      if (EmtId != "" && !EmtId.startsWith('EMT')) {
        document.getElementById("EMT_id_err").innerHTML = "Supplier ID start with EMT";
        document.getElementById("EMT_id_err").style.color = "red";
        this.IsErr = true;
      } else {
        document.getElementById("EMT_id_err").innerHTML = "";
        this.IsErr = false;
      }
    }
  }
  supplierIdValidation() {

    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details.supplier_id = this.search_details.supplier_id.toUpperCase();
    var supplierId = this.search_details.supplier_id;

    if (supplierId != "" && regex.test(supplierId) == false) {
      document.getElementById("supplier_id_err").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("supplier_id_err").style.color = "red";
      this.IsErr = true;
    } else {
      if (supplierId != "" && supplierId.startsWith('EMT')) {
        document.getElementById("supplier_id_err").innerHTML =
          "Enter Valid Supplier ID";
        document.getElementById("supplier_id_err").style.color = "red";
        this.IsErr = true;
      } else {
        document.getElementById("supplier_id_err").innerHTML = "";
        this.IsErr = false;
      }
    }
  }

  toggleDisable2() {
    this.search_details.bookingdate_to = "";   
  }

  checkempty() {
    if (
      this.search_details.jp_number.length == 0 &&
      this.search_details.last_name.length == 0 &&
      this.search_details.first_name.length == 0 &&
      this.search_details.airlinepnr.length == 0 &&
      this.search_details.order_id.length == 0 &&
      this.search_details.status == "E"
    ) {
      this.disablebtn = true;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.last_name.length != 0 ||
        this.search_details.first_name.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.order_id.length != 0 ||
        this.search_details.status != "E") &&
      (this.search_details.bookingdate_from != "" &&
        this.search_details.bookingdate_to != "")
    ) {
      this.disablebtn = false;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.last_name.length != 0 ||
        this.search_details.first_name.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.order_id.length != 0 ||
        this.search_details.status != "E") &&
      (this.search_details.bookingdate_from == "" &&
        this.search_details.bookingdate_to == "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.search_details.bookingdate_from == "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.disablebtn = true;
    }

    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to == ""
    ) {
      this.disablebtn = true;
    }
  }

  checkStatus1() {
    this.mydate = this.search_details.bookingdate_from;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.downd = false;
      //  this.disablebtn = true;
      // this.checkempty();
    } else {
      this.downd = true;
    }
  }

  reset() {
    this.input9.value = "";
    this.search_details.tripdate_to = "";
    this.tomorrow = "";
    this.isEmpty();
  }

  reset2() {
    this.input2.value = "";
    this.search_details.tripdate_From = "";
    this.isEmpty();
  }

  reset3() {
    this.input3.value = "";

    this.search_details.bookingdate_from = "";
    this.tomorrow1 = "";
    this.isEmpty();
  }

  reset4() {
    this.input4.value = "";
    this.search_details.bookingdate_to = "";
    this.isEmpty();
  }

  checkDate() {
    this.invaliddate = false;
    if (
      this.search_details.bookingdate_to != " " &&
      this.search_details.bookingdate_to != "" &&
      this.search_details.bookingdate_to != null
    ) {
      if (
        this.search_details.bookingdate_from >=
        this.search_details.bookingdate_to
      ) {
        this.invaliddate = true;
      }
    }
  }

  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);
    console.log(tomorrow, "tomorrow");
    this.final = tam.setDate(tam.getDate());
    console.log("finaldate", this.final)
    this.final = new Date(this.final);

    // alert(this.final);
    //alert(this.search_details.bookingdate_from);
  }
  set_dept_to: any
  setDepartureTo() {

    var today = (document.getElementById('deptfrom') as HTMLInputElement).value;
    // console.log("111111",today)
    var tam = new Date(today);
    //  console.log(today,"tomorrow");
    this.set_dept_to = tam.setDate(tam.getDate());
    // console.log("finaldate",this.set_dept_to)
    this.set_dept_to = new Date(this.set_dept_to);
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    console.log("event=====njsdcjd=====", event);

    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }
  getAncillaryDetail(Booking_Ref) {
    return new Promise((resolve, reject) => {
      this.vernostService.getAncillaryData({ "ORDER_ID": Booking_Ref }).subscribe((result) => {
        var data_result = result[0]["result"];
        console.log("ancill result:", data_result)
        if ((this.search_details["ancillary_type"] == "" && this.search_details["ancillary_status"] == "") ||
          ((this.search_details["ancillary_type"] != "E" ||
            this.search_details["ancillary_type"] != "") && this.search_details["ancillary_status"] == "")) {
          resolve(true);
        }
        else {
          if (data_result.length == 0) {
            if (this.search_details["ancillary_status"] == "1") {
              resolve(true);
            }
            else {
              resolve(false);
            }
          }
          for (var i = 0; i < data_result.length; i++) {
            var item = data_result[i];
            if ((this.search_details["ancillary_type"] == "" || this.search_details["ancillary_type"] == item["SSR_TYPE"]) && this.search_details["ancillary_status"] == item["BOOKING_STATUS"]) {
              resolve(true);
            }
          }
        }
        resolve(false)
      })
    })
  }
}
